import React from "react";

const MenuButton = ({ title, onClick, txColor }) => {
	return (
		<button
			onClick={onClick}
			className={`font-semibold ${
				txColor ? "text-orange-500" : "text-gray-400"
			} hover:text-orange-600 active:text-orange-700`}
		>
			{title}
		</button>
	);
};

export default MenuButton;
